export const isValidEmail = (email: string) => {
  const emailRegex = new RegExp(
    /^([+\w-]+(?:\.[+\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i,
  );

  return emailRegex.test(email);
};
